import { Button } from '@mui/material';
import { useSnackbar, VariantType } from 'notistack';
import { useEffect } from 'react';
import { useNotificationStore } from '../../store/storeNotifications';

const DEFAULT_DURATION = 3000;

const Notification = () => {
  const { notification } = useNotificationStore(state => state);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (!notification?.message) {
      return;
    }
    const duration =
      notification.duration !== undefined
        ? notification.duration
        : DEFAULT_DURATION;
    const action = notification.action;
    enqueueSnackbar(notification.message, {
      variant: notification.type as VariantType,
      autoHideDuration: duration,
      preventDuplicate: true,
      persist: notification.persist,
      key: notification.key,
      action: action
        ? snackbarKey => (
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                action.onClick();
                closeSnackbar(snackbarKey);
              }}
            >
              {action.label}
            </Button>
          )
        : undefined,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    });
  }, [notification, enqueueSnackbar, closeSnackbar]);

  return null;
};

export default Notification;
